<div class="records-page records-page--campaigns">
   <div class="datatable-page-shell">
      <div class="records-page__hero">
         <div class="records-page__hero-primary">
            <div class="records-page__hero-headline">
               <span class="records-page__hero-eyebrow">{{ 'CAMPAIGNS' | translate }}</span>
               <h3 class="records-page__hero-title">{{ 'YOUR_CAMPAIGNS' | translate }}</h3>
            </div>
         </div>
         <div class="records-page__hero-aside">
            <div class="records-page__hero-actions">
               <ng-select class="campaign-saved-search-select" [items]="campaignSavedSearches" bindLabel="name" bindValue="id"
                  [placeholder]="'SAVED_SEARCHES' | translate" [(ngModel)]="selectedSavedSearchId"
                  (ngModelChange)="onSavedSearchChange($event)" [clearable]="true">
               </ng-select>
               <button type="button" class="gray-button gray-button--toggle campaign-filter-button" *ngIf="doWhat.isAdmin" (click)="showDeleted = !showDeleted; onShowDeletedChange()">
                  <label class="gray-button__toggle-content" for="showDeleted" (click)="$event.stopPropagation()">
                     <input type="checkbox" id="showDeleted" [(ngModel)]="showDeleted" (change)="onShowDeletedChange()" value="Show Deleted Campaigns">
                     {{ 'SHOW_DELETED_CAMPAIGNS' | translate }}
                  </label>
               </button>
               <button type="button" (click)="onAddCampaign()" class="blue-button campaign-page-action" *ngIf="doWhat.isAdmin || doWhat.canCreate">{{ 'ADD_CAMPAIGN' | translate }}</button>
            </div>
         </div>
      </div>
      <div class="datatable-page-surface">
         <app-campaign-datatable class="records-page__table" [iShowDropdownAdd]="true" [iColumns]="columns" [iCanRead]="doWhat.canRead" [iCanWrite]="doWhat.canWrite"
            [iCanDelete]="doWhat.canDelete" [iRowLinkHandler]="getRowLink" (oDeleteRows)="deleteRows($event)" [iShowMerge]="doWhat.isAdmin || userRoles.includes(ROLES.TechServices.Code)"
            (oMergeRecords)="handleMergeRecordsClicked($event)" (oEditRow)="editRow($event)" [iData$]="campaignsData" [iIsServerLoading]="true" [iTotalCount]="dataTotalCount" 
            (oLoadDataFromServer)="onLoadingData($event)" (oCustomDataExport)="export()" [iIsCustomDataExport]="true"></app-campaign-datatable>
      </div>
   </div>
</div>